import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Broj strane živi u adresi, ne u stanju komponente.
 *
 * Dok je stajao u `useState`, put od spiska do dokumenta i nazad gubio je mesto: korisnik sa
 * sedme strane otvori porudžbinu, pritisne nazad i osvane na prvoj. Adresa to rešava sama, jer
 * pregledač pamti nju, pa povratak vraća i stranu.
 *
 * Usput se i veza može poslati nekome takva kakva je, sa stranom na kojoj si bio.
 *
 * Promena strane ne upisuje novu stavku u istoriju (`replace`), inače bi listanje kroz dvadeset
 * strana značilo dvadeset pritisaka na „nazad" da bi se izašlo sa spiska.
 */
export function usePage(kljuc = "page"): [number, (p: number) => void] {
  const [params, setParams] = useSearchParams();
  const sirovo = Number.parseInt(params.get(kljuc) ?? "", 10);
  const strana = Number.isFinite(sirovo) && sirovo > 0 ? sirovo - 1 : 0;

  const postavi = useCallback(
    (p: number) => {
      setParams(
        (prethodni) => {
          const sledeci = new URLSearchParams(prethodni);
          // Prva strana se ne piše: `?page=1` u adresi je šum koji ništa ne kaže.
          if (p <= 0) sledeci.delete(kljuc);
          else sledeci.set(kljuc, String(p + 1));
          return sledeci;
        },
        { replace: true },
      );
    },
    [kljuc, setParams],
  );

  return [strana, postavi];
}
